import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

interface LikedPostsViewProps {
  onBack: () => void;
}

export const LikedPostsView = ({ onBack }: LikedPostsViewProps) => {
  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2">
        <Button variant="ghost" size="icon" onClick={onBack}>
          <ArrowLeft className="h-4 w-4" />
        </Button>
        <h3 className="font-semibold">Liked Posts</h3>
      </div>
      <div className="text-sm text-muted-foreground text-center py-8">
        Your liked posts will appear here
      </div>
    </div>
  );
};